export default __webpack_public_path__ + "static/article-travel-destination-healthy-6e4e3e4657eb43e0c35ac47a286a9f39.webp";